module.exports = __webpack_public_path__ + "img/ziliao_banner_es.80bb99b9.jpg";